// Flow
import React from 'react';
import classNames from 'classnames/bind';

import styles from './TabItem.module.scss';;

const cx = classNames.bind(styles);
type Props = {
  children: any,
  active?: boolean,
  disabled?: boolean,
};

const TabItem = ({ children, active, disabled }: Props) => (<div className={cx({ root: true, active, disabled })}>
  {typeof children === 'function'
    ? children({ active })
    : children}
</div>);

export default TabItem;
